<template lang="pug">
.d-flex.flex-column
  .d-flex.align-items-center.flex-wrap
    //- start time
    input.register-form.datetime.mr-1(v-model="_baseStartTime" :name="name + '-start'" type="text"
      v-validate="{ required: true }" data-vv-as="外出外泊可能時間（外泊はお迎え時間と帰所時間） 開始時間"
      @click="showStartModal" readonly)
    b-button.clear-btn(@click="onDeleteStartTime")
      span クリア

    //- separator
    span.mr-3.ml-3 ～

    //- end time
    input.register-form.datetime.mr-1(v-model="_baseEndTime" :name="name + '-end'" type="text"
      v-validate="{ required: true }" data-vv-as="外出外泊可能時間（外泊はお迎え時間と帰所時間） 終了時間"
      @click="showEndModal" readonly)
    b-button.clear-btn(@click="onDeleteEndTime")
      span クリア

    //- delete button
    b-button.clear-btn.ml-3(@click="onDelete")
      span 削除

  //- error messages
  .error-messages(v-if="0 < errors.collect(name + '-start').concat(errors.collect(name + '-end')).length")
    label.error-message(v-for="error in errors.collect(name + '-start').concat(errors.collect(name + '-end'))") {{ error }}
      br

  //- modals
  TimePickerModal(v-model="showStartTimeInputModal" :time.sync="_startTime" :minutes-step="minutesStep" @ok="inputStartTime" @cancel="resetStartTime")
  TimePickerModal(v-model="showEndTimeInputModal" :time.sync="_endTime" :minutes-step="minutesStep" @ok="inputEndTime" @cancel="resetEndTime")
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import TimePickerModal from "@/pc/basics/TimePickerModal.vue";

@Component({
  components: {
    TimePickerModal
  }
})
export default class InputOutingAvailableTime extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 外出外泊可能時間 */
  @Prop({ required: true })
  value!: InputOutingAvailableTimeModel;

  /** 分の追加値 */
  @Prop({ default: () => 15 })
  minutesStep!: number;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** 開始時間の入力モーダル表示可否 */
  showStartTimeInputModal: boolean = false;
  /** 終了時間の入力モーダル表示可否 */
  showEndTimeInputModal: boolean = false;

  public showStartModal(): void {
    this.showStartTimeInputModal = true;
    return;
  }

  public showEndModal(): void {
    this.showEndTimeInputModal = true;
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _baseStartTime(): string {
    if (this.value.baseStartTime) {
      const deisplayTime: string[] = this.value.baseStartTime.split(":");
      return deisplayTime[0] + "：" + deisplayTime[1];
    } else {
      return "";
    }
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _baseEndTime(): string {
    if (this.value.baseEndTime) {
      const deisplayTime: string[] = this.value.baseEndTime.split(":");
      return deisplayTime[0] + "：" + deisplayTime[1];
    } else {
      return "";
    }
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _startTime(): string {
    return this.value.startTime;
  }

  set _startTime(newValue: string) {
    this.value.startTime = newValue;
    this.$emit("input", this.value);
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _endTime(): string {
    return this.value.endTime;
  }

  set _endTime(newValue: string) {
    this.value.endTime = newValue;
    this.$emit("input", this.value);
    return;
  }

  onDeleteStartTime(): void {
    this.value.baseStartTime = null;
    this.$emit("input", this.value);
    return;
  }

  onDeleteEndTime(): void {
    this.value.baseEndTime = null;
    this.$emit("input", this.value);
    return;
  }

  inputStartTime(): void {
    this.value.baseStartTime = this.value.startTime;
    this.$emit("input", this.value);
    return;
  }

  inputEndTime(): void {
    this.value.baseEndTime = this.value.endTime;
    this.$emit("input", this.value);
    return;
  }

  resetStartTime(): void {
    console.log("this.value.baseStartTime", this.value.baseStartTime);
    this.value.startTime = this.value.baseStartTime as string;
    this.$emit("input", this.value);
    return;
  }

  resetEndTime(): void {
    console.log("this.value.baseEndTime", this.value.baseEndTime);
    this.value.endTime = this.value.baseEndTime as string;
    this.$emit("input", this.value);
    return;
  }

  onDelete(): void {
    this.$emit("onDelete");
    return;
  }
}

export interface InputOutingAvailableTimeModel {
  /** 外出外泊可能時間（開始） */
  baseStartTime: string | null;
  /** 外出外泊可能時間（開始） */
  startTime: string;
  /** 外出外泊可能時間（終了） */
  baseEndTime: string | null;
  /** 外出外泊可能時間（終了） */
  endTime: string;
}
</script>

<style lang="scss" scoped>
.register-form {
  min-width: 124px !important;
  width: 124px !important;
}
</style>
